<template>
  <el-select
    :value="value"
    v-bind="$attrs"
    ref="select"
  >
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.label"
    >
    </el-option>
  </el-select>
</template>

<script>
  import proxy from './proxy'

  export default {
    inheritAttrs: false,
    mixins: [proxy],
    props: {
      value: [String, Number],
      list: Array
    }
  }
</script>
